// Importar AOS
import AOS from 'aos';
import 'aos/dist/aos.css';

export default class Header {
	constructor() {
		this.header = document.querySelector("header");
		this.menu = document.querySelector(".btnMobileMenu");
		this.menuOpen = document.querySelector(".menu-header-container");

		this.linkWhats = this.header?.querySelector('.linkWhats');
		
		this.ready();
        this.scroll();
		
		// Inicializar AOS
		AOS.init({
			once: true
		});
		
		this.actionGoToTop()
	}

	ready() {
		if (this.menu) {
			this.menu.addEventListener("click", () => {
				this.toggleMenu();
			}, false);
		}

		// Fechar ao clicar em qualquer link do menu
		if (this.menuOpen) {
			this.menuOpen.querySelectorAll("a").forEach(link => {
				link.addEventListener("click", () => {
					this.closeMenu();
				});
			});
		}
	}

	toggleMenu() {
		this.menuOpen.classList.toggle("active");
		this.menu.classList.toggle("active");
		this.header.classList.toggle("showMenu");

		if (document.querySelector(".home")) {
			this.header.classList.toggle("active");
		} else {
			if (!this.header.classList.contains("active")) {
				this.header.classList.add("active");
			}
		}

		if (this.menu.classList.contains("active")) {
			this.header.classList.add("active");
		}

		if (this.linkWhats) {
			this.linkWhats.classList.toggle("active");
		}
	}

	closeMenu() {
		this.menuOpen.classList.remove("active");
		this.menu.classList.remove("active");
		this.header.classList.remove("showMenu");

		if (this.linkWhats) {
			this.linkWhats.classList.remove("active");
		}
	}

    scroll() {
    let lastScrollTop = 0;

    window.addEventListener('scroll', () => {
        let currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

        // Adiciona fundo quando passa de 60px
        if (currentScrollTop > 60) {
            this.header.classList.add('showHeader');
        } else {
            this.header.classList.remove('showHeader');
        }

        // Verifica direção do scroll
        if (currentScrollTop > lastScrollTop && currentScrollTop > 100) {
            // Rolando para baixo → esconde
            this.header.classList.add('hideHeader');
        } else {
            // Rolando para cima → mostra
            this.header.classList.remove('hideHeader');
            this.header.classList.add('fixedHeader');
        }

        // Se chegou no topo → remove fixed
        if (currentScrollTop <= 0) {
            this.header.classList.remove('fixedHeader');
        }

        lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
    });
}


	actionGoToTop() {
        const btnGoToTop = document.querySelector('.btnGoToTop');

        if (btnGoToTop) {
            btnGoToTop.addEventListener('click', () => {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            });
        }
    }
}

new Header();
